import React, { useState, useEffect } from "react";
import hero1 from "../../images/WW-Hero-1.jpg";
import icon1 from "../../images/WW-Icon-Pooled.gif";
import icon2 from "../../images/WW-Icon-Track.gif";
import icon3 from "../../images/WW-Icon-Destiny.gif";
import icon4 from "../../images/WW-Icon-IP.gif";
import icon5 from "../../images/WW-Icon-Operational.gif";
import image1 from "../../images/WW-Image-Institution.jpg";
import image2 from "../../images/WW-Image-Food.jpg";
import image3 from "../../images/WW-Image-Fun.jpg";
import Homesliders from "../../components/Homesliders/index.js";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";

import styles from "./index.module.css";

export default function HomePage() {
	const bannerIcons = [icon1, icon2, icon3, icon4, icon5];

	const [width, setWidth] = useState(window.innerWidth);
	const mobile = 414;
	const tablet = 800;
	useEffect(() => {
		const handleWindowResize = () => setWidth(window.innerWidth);
		window.addEventListener("resize", handleWindowResize);
		return () => window.removeEventListener("resize", handleWindowResize);
	}, []);

	return (
		<div className={styles.HomePage}>
			<Helmet>
				<title>Wet Willie's Franchise</title>
			</Helmet>
			<div className={styles.figureContainer}>
				<figure className={styles.figure}>
					<img className={styles.img} src={hero1} alt="hero" />
				</figure>
			</div>
			<div className={styles.section1}>
				<div className={styles.subsection1_1}>
					<h2>OVER 30 YEARS OF PROVEN SUCCESS</h2>
				</div>
				{width > mobile ? (
					<div className={styles.subsection1_2}>
						<ul className={styles.ul}>
							{bannerIcons.map((icon, i) => (
								<li className={styles[`li${i.toString()}`]}>
									<figure className={styles.figure}>
										<Link
											to="/reasons_to_invest"
											className={styles.link}
										>
											<img src={icon} alt="icons" />
										</Link>
									</figure>
								</li>
							))}
						</ul>
					</div>
				) : (
					<div className={styles.blueStripe}></div>
				)}
				<article className={styles.article}>
					<section className={styles.section}>
						{width > mobile ? (
							<div className={styles.figureContainer}>
								<figure>
									<img src={image1} alt="wetwillies" />
								</figure>
							</div>
						) : null}
						<div className={styles.paragraph}>
							<div className={styles.paragraphContainer}>
								<h3>AN INSTITUTION</h3>
								<p>
									Wet Willie's began in 1988 by a small group
									of friends. The group began the research
									required to fuse the daiquiri concept with a
									casual, upbeat atmosphere, yielding the
									right mix of flavor, fun, and success. Our
									goal was to exceed our guests' expectation
									of a bar and a party, and to become an
									institution. We have surpassed our goal and
									are now a world-renowned institution serving
									the world's greatest frozen daiquiris.
								</p>
								<Link to="/about" className={styles.link}>
									<button>MORE</button>
								</Link>
							</div>
						</div>
					</section>
					<section className={styles.section}>
						{width > mobile && width < tablet ? (
							<div className={styles.figureContainer2}>
								<figure>
									<img src={image2} alt="burger" />
								</figure>
							</div>
						) : null}
						<div className={styles.paragraph}>
							<div className={styles.paragraphContainer2}>
								<h3>UNCOMPLICATED & SUPERIOR</h3>
								<p>
									Our food items are prepared from quality
									ingredients. Overseen by our professional
									Chef, our recipes have been perfected over
									our 32 year history. Preparation is
									relatively uncomplicated and the results are
									superior. Systems have been established to
									assist in controlling food costs and
									inventories.
								</p>
								<Link
									to="/reasons_to_invest"
									className={styles.link}
								>
									<button>MORE</button>
								</Link>
							</div>
						</div>
						{width > mobile && width > tablet ? (
							<div className={styles.figureContainer2}>
								<figure>
									<img src={image2} alt="burger" />
								</figure>
							</div>
						) : null}
					</section>
					<section className={styles.section}>
						{width > mobile ? (
							<div className={styles.figureContainer}>
								<figure>
									<img src={image3} alt="person" />
								</figure>
							</div>
						) : null}
						<div className={styles.paragraph}>
							<div className={styles.paragraphContainer}>
								<h3>WET WILLIE'S = FUN</h3>
								<p>
									Our superior food and beverages are
									complimented by an equally superior
									environment. From our friendly, well-trained
									staff to our beautiful murals, everything
									about Wet Willie's spells FUN. Our friendly
									employees are always happy to assist our
									guests. Great food, great drinks, great
									people and an awesome time: that's what
									we're about
								</p>
								<Link
									to="/request_information"
									className={styles.link}
								>
									<button>MORE</button>
								</Link>
							</div>
						</div>
					</section>
				</article>
				<div className={styles.section2}>
					<h2>GET STARTED!</h2>
					<p>Thank you for your interest in Wet Willie's! </p>
					<p>
						Complete this information request form and we can begin
						the process of qualifying you. We will contact you
						directly, typically within two weeks, to discuss
						furthering the process and putting you on the road to
						support global cooling.
					</p>
					<br />
					<p>
						Please Note, Minimum liquid capital investment is $500k
					</p>
					<Link to="/request_information">
						<button>LET'S GO</button>
					</Link>
					<span>TERMS AND CONDITIONS</span>
					<span>
						This is not an offer of a franchise, Offers only will be
						made through our Uniform Franchise Offering Circular
						'FRANCHISE DISCLOSURE DOCUMENT In states with laws which
						require franchises to be registered, an offer will not
						be made unless or until the franchise is registered.
						Those states include CA, HI, WA, ND, SD, MN, WI, IL, IN,
						MI, RI, NY, MD and VA.
					</span>
				</div>
				<Homesliders />
			</div>
		</div>
	);
}
